import { useHttpMutate } from '../global/hooks/api';
import { sendConfirmationLink } from './endpoint';

export const useSendConfirmationLink = () => useHttpMutate(sendConfirmationLink);
